import { render } from "./CoursesGridPage.vue?vue&type=template&id=cbe10514&ts=true"
import script from "./CoursesGridPage.vue?vue&type=script&lang=ts"
export * from "./CoursesGridPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__